<template>
  <div>
    <!-- email -->
    <div class="content">
      <img class="email_fanhui fanzhuan" src="../assets/img/cz_web_return.png" @click="goback()">
      <div class="email_content">
        <div><img class="email_img" src="../assets/img/cz_web_mail.png"></div>
        <p class="email_contact">{{$t('m.contact_email')}}</p>
        <p class="email_desc">{{$t('m.provide_email')}}</p>

        <p class="email_form_title">{{$t('m.email_address')}}</p>
        <input type="email" name="email" v-model="emailVal" :placeholder="$t('m.email_place_holder')" class="email_form_input" />

        <div class="email_form_btn" :class="{'active':emailIsTrue}" @click="submitEmail()">{{$t('m.submit')}}</div>

      </div>
      <p class="fc-notice" v-html="$t('m.buy-notice-a', {msg: curHost})" v-if="isInBuzzCast"></p>
    </div>
    <!-- email end -->
    <p class="fc-notice ask" v-if="isInBuzzCast">
      <img src="../assets/img/question_icon.png" class="fc-icon-sm">
      <a href="#/asks" class="fc-color-gray">{{$t('m.rechargeFAQ_title')}}</a>
    </p>

  </div>
</template>

<script>
import {getAppName, getDomainCountryFiled, isNotBuzzCast} from "../util";

var _self;
import Vue from 'vue';
import { Toast,Dialog } from 'vant';
Vue.use(Toast);
Vue.use(Dialog);
import { exitLogin } from "@/tools/common.js";
import { createOrderAjax} from "@/api/pay.js";
import { loadingWebp } from '../assets/img/loading';
import multiDomain from "../mixins/multiDomain";
  export default {
    mixins: [multiDomain],
    data() {
      return {
        emailVal: '',
        emailIsTrue: false,
        selPayStyleId: '',
        selPayStyleNormId: '',
        countryCode: '',
        userInfo: '',
        userId:'',
        token: '',
        curHost: window.location.host,
        domainCountry: null,
        from: null,
        appName: getAppName(),
      }
    },
    watch: {
      emailVal(val) {
        //console.log(val);
        var reg = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
        if (!reg.test(val)) {
          //Toast();
          this.emailIsTrue = false;
        } else {
          this.emailIsTrue = true;
        }
      },
    },
    filters: {

    },
    mounted() {
      _self = this;
      // console.log(_self.$route.params);
      _self.userId = _self.$route.params.userId;
      _self.token = _self.$route.params.token;
      _self.selPayStyleId = _self.$route.params.selPayStyleId;
      _self.selPayStyleNormId = _self.$route.params.selPayStyleNormId;
      _self.countryCode = _self.$route.params.countryCode;
      _self.from = _self.$route.params.from;
      if (!_self.selPayStyleId || !_self.selPayStyleNormId) {
        _self.$router.replace({
          path: '/'
        })
      }
      let localEmail = localStorage.getItem('bcpayEmail');
      let bcpayLoginEmail = localStorage.getItem('bcpayLoginEmail');
      if(localEmail){
        _self.emailVal = localEmail;
      }else if(bcpayLoginEmail){
        _self.emailVal = bcpayLoginEmail;
      }
    },
    methods: {
      goback(){
        window.history.go(-1)
      },
      //提价邮箱
      submitEmail() {
        if (_self.emailIsTrue) {
          localStorage.setItem('bcpayEmail',_self.emailVal);
          _self.createOrderPay(_self.selPayStyleId, _self.selPayStyleNormId, _self.emailVal);
        } else {
          console.log("email error");
        }

      },
      createOrderPay(payPlatformId, rechargeId, email) {
        if (payPlatformId == 2) {
          localStorage.setItem("IsWeChatPay", 'true');
        } else {
          localStorage.setItem("IsWeChatPay", 'false');
        }

        var param = {
          "systoken": _self.token,
          "userId": _self.userId,
          "rechargeId": rechargeId,
          "countryCode": _self.countryCode,
          "email": email || '',
          domainCountry: getDomainCountryFiled(),
          from: _self.from,
        };
        console.log(JSON.stringify(param));
        //return false;
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });
        let newWindow = null;
        if (payPlatformId == 3 || payPlatformId == 10075 || payPlatformId === 10076 || payPlatformId === 10078) {
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            const loadingHtml = `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Redirecting to payment...</title>
                </head>
                <body>
                </body>
                </html>
            `;
            newWindow = window.open(`data:text/html;base64,${btoa(loadingHtml)}`, '_blank')
          } else {
            newWindow = window.open('', '_blank')
            newWindow.document.body.innerHTML = `
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <img style="width: 140px; height: 60px;" src="${loadingWebp.base64}" alt="">
              </div>
            `
          }
          newWindow.document.title = 'Redirecting to payment...'
        }
        createOrderAjax(param,payPlatformId).then((res) => {
          // 若下单结果被标记为 fail，则阻止后续处理
          if (res && (res.fail || (res.data && res.data.fail))) {
            newWindow && newWindow.close();
            Toast.clear();
            return;
          }
          Toast.clear();
          if (res.data.code == 1) {
            var tradeNo = res.data.result.tradeNo;
            //跳转第三方
            if (payPlatformId == 3 || payPlatformId == 10075) {
              //3 代表paypal, 10075代表新账号paypal
              const targetUrl = _self.global_paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl)
            } else if(payPlatformId === 10076) {
              //10076 代表意大利的paypal
              const targetUrl = process.env.paypalUrl_IT + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl)
            } else if(payPlatformId === 10078) {
              //10078 paypal新充值
              const targetUrl = process.env.paypalUrl_10078 + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl)
            }else {
              window.location.href = _self.global_apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            }
          } else if (res.data.code == 6000) {
            newWindow && newWindow.close()
            Dialog.alert({
              message: this.$t('m.pay_fail_system_risk') + ', ' + this.$t('m.support_contant_whatsapp', { msg: this.appName }),
              confirmButtonText: 'OK',
            }).then(() => {
              // on close
            });
          } else if (res.data.code == 6001) {
            newWindow && newWindow.close()
            Dialog.alert({
              message: this.$t('m.paystyle_unavailabel_change_other') + this.$t('m.support_contant_whatsapp', { msg: this.appName }),
              confirmButtonText: 'OK',
              getContainer: '#payindex'
            }).then(() => {
                // on close
            });
          } else if(res.data.code == -1) {
            newWindow && newWindow.close()
            exitLogin();
          }
        }).catch((error) => {
          newWindow && newWindow.close()
          console.log(error) //  错误处理 相当于error
          Toast(error.message);
        })

      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/email.vue